import { useIntl } from "react-intl";

import {
  SelectBoxBase,
  type Option,
} from "../../../../common/components/forms/select-box/SelectBox";

const options: Option<string>[] = [
  { value: "en-US", label: "EN" },
  { value: "cs-CZ", label: "CZ" },
  { value: "es-ES", label: "ES" },
  { value: "ro-RO", label: "RO" },
  { value: "hu-HU", label: "HU" },
  { value: "pl-PL", label: "PL" },
  { value: "sk-SK", label: "SK" },
  { value: "lt-LT", label: "LT" },
];

type LangSwitchProps = {
  onLangChange?: (locale: string) => void;
  className?: string;
};

const LangSwitch = (props: LangSwitchProps): JSX.Element => {
  const { className = "", onLangChange = () => {} } = props;
  const intl = useIntl();

  return (
    <div className={className} id="lang-switch">
      <SelectBoxBase
        fullWidth
        name="lang"
        onChange={onLangChange}
        options={options}
        value={intl.locale}
      />
    </div>
  );
};

export { LangSwitch };
export { options };
